import '../../assets/css/case-property.css';
import cornerIcon from '../../assets/images/case-image-corner.svg';
// @ts-ignore
import { useProperty, useContentToken, EditableToken, RichTextContent } from '@vibesites/runtime/react';
// @ts-ignore
import type { ComponentContentSchema } from '@vibesites/runtime';
import { getPropertyBasePath } from './propertyUtils';
import { PropertyContentSection } from './PropertyContentSection';
import { NeighborhoodMapEmbed } from './NeighborhoodMapEmbed';

/**
 * Neighborhood preview section for the home page.
 * Renders the custom neighborhood map embed alongside description text + CTA.
 */
export function PropertyNeighborhoodPreview() {
  const property = useProperty();

  const basePath = getPropertyBasePath(property);
  const ctaText = useContentToken('propertyneighborhood.cta_text') || 'More About Our Neighborhood';

  return (
    <PropertyContentSection
      variant="dark"
      left={
        <div style={{ position: 'relative' }}>
          <img src={cornerIcon} alt="" className="prop-corner-icon prop-corner-icon--tl" aria-hidden="true" />
          <div className="prop-map-wrapper">
            <NeighborhoodMapEmbed height="450px" showCategories={true} />
          </div>
        </div>
      }
      right={
        <div className="prop-al-text-box">
          <RichTextContent path="propertyneighborhood.title" label="Section Title" defaultValue={contentSchema.tokens['propertyneighborhood.title'].defaultValue} as="h2" className="prop-section-title" />
          <div className="prop-al-separator" />
          <RichTextContent
            path="propertyneighborhood.blurb"
            label="Description"
            defaultField={contentSchema.tokens['propertyneighborhood.blurb'].defaultField}
            defaultValue={contentSchema.tokens['propertyneighborhood.blurb'].defaultValue}
            as="div"
            className="prop-al-blurb"
          />
          <EditableToken path="propertyneighborhood.cta_text" type="text" label="CTA Button Text" as="span" style={{ display: 'contents' }} defaultValue={contentSchema.tokens['propertyneighborhood.cta_text'].defaultValue}>
            <a className="prop-btn" href={`${basePath}/neighborhood/`}>{ctaText}</a>
          </EditableToken>
        </div>
      }
    />
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PropertyNeighborhood',
  displayName: 'Property Neighborhood Preview',
  collectionBindings: {
    'propertyneighborhood.map_pois': {
      collection: 'neighborhood_pois',
      label: 'Map POIs',
    },
  },
  tokens: {
    'propertyneighborhood.title': {
      label: 'Section Title',
      type: 'richtext',
      defaultValue: 'Experience the Best of <span data-type="field-token" data-field="property_address_city"></span> at Our Upscale Apartment Rentals',
    },
    'propertyneighborhood.blurb': {
      label: 'Description',
      type: 'richtext',
      defaultField: 'property_home_neighborhood_blurb',
      defaultValue: 'Discover the vibrant neighborhood surrounding <span data-type="field-token" data-field="property_name"></span>.',
    },
    'propertyneighborhood.cta_text': {
      label: 'CTA Button Text',
      type: 'text',
      defaultValue: 'More About Our Neighborhood',
    },
  },
};

(PropertyNeighborhoodPreview as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PropertyNeighborhoodPreview;
